import React, { useState } from 'react';

interface GradeSelectionModalProps {
  email: string;
  onSelect: (grade: number) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

const grades = [
  { value: 0, label: 'K' },
  { value: 1, label: '1st' },
  { value: 2, label: '2nd' },
  { value: 3, label: '3rd' },
  { value: 4, label: '4th' },
  { value: 5, label: '5th' },
];

const GradeSelectionModal: React.FC<GradeSelectionModalProps> = ({
  email,
  onSelect,
  onCancel,
  isSubmitting,
}) => {
  const [selectedGrade, setSelectedGrade] = useState<number | null>(null);

  const handleConfirm = () => {
    if (selectedGrade !== null) {
      onSelect(selectedGrade);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Select your grade</h2>
        <p className="modal-subtitle">
          Welcome! Setting up your account for {email}
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '10px',
        }}>
          {grades.map((g) => (
            <button
              key={g.value}
              onClick={() => setSelectedGrade(g.value)}
              disabled={isSubmitting}
              style={{
                padding: '14px 10px',
                border: `2px solid ${selectedGrade === g.value ? 'var(--primary-color)' : 'var(--border-color)'}`,
                borderRadius: 'var(--radius)',
                background: selectedGrade === g.value ? 'var(--primary-light)' : 'var(--card-background)',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                textAlign: 'center',
                fontFamily: 'inherit',
                transition: 'border-color 0.15s, background 0.15s',
              }}
            >
              <div style={{
                fontSize: '1.25rem',
                fontWeight: 700,
                color: selectedGrade === g.value ? 'var(--primary-color)' : 'var(--text-color)',
              }}>
                {g.label}
              </div>
              <div style={{
                fontSize: '0.7rem',
                color: 'var(--text-secondary)',
                marginTop: '2px',
              }}>
                {g.value === 0 ? 'Kindergarten' : `Grade ${g.value}`}
              </div>
            </button>
          ))}
        </div>

        <div className="modal-actions">
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={selectedGrade === null || isSubmitting}
          >
            {isSubmitting ? 'Creating account...' : 'Continue'}
          </button>
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default GradeSelectionModal;
